export default {
  // 日期選擇器
  dateRangeSeparator: "→",
  startDatePlaceholder: "開始日期",
  endDatePlaceholder: "結束日期",

  // 按鈕
  reset: "重置",
  query: "查詢",

  // 數據統計
  totalData: "共計{count}條數據",

  // 加載
  loading: "拼命加載中",

  // 行為類型
  withdrawal: "提現",
  deposit: "充值",
  buy: "買入",
  sell: "賣出",
  unknown: "未知",

  // 加載更多
  loadMore: "加載更多數據",
  collapse: "收起",

  // 空狀態
  noData: "暫無數據",
};
